import AppBar from "material-ui/AppBar";

export default AppBar;



// WEBPACK FOOTER //
// ./src/components/uielements/appbar/index.js